import { FC } from 'react';
import { usePermission, useTranslation } from 'hooks';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import tableNames from 'constants/tableNames';
import permissionReasons from 'constants/permissionReasons';
import { getMassPayouts } from 'api/payments';
import getConfigurationByName from 'selectors/getConfigurationByName';
import { RootState } from 'store';
import { getPathUrl } from 'helpers/paymentsPayoutsRequest';
import filtersKeys from 'constants/filters';
import Button from 'components/ui/button';
import DataListContainer from 'components/dataListContainer';
import TopPanelContainer from 'components/topPanel';
import { Column, Row } from 'components/ui/table';
import { manualPaymentsTabs } from '../ManualPaymentsForm';
import getQuickFiltersValues from 'selectors/getQuickFiltersValues';
import { quickFiltersConfig } from './quickFiltersConfig';
import { getQuickFiltersConfig } from 'helpers/wlResolver';
import { useWl } from 'providers/WlProvider';

export const ManualPaymentsList: FC = () => {
  const { wlId } = useWl()
  const history = useHistory();
  const getTranslate = useTranslation();
  const { isEnabled, isDisabledByReason } = usePermission();
  const configuration = useSelector((state: RootState) =>
    getConfigurationByName(state, tableNames.manualPayments)
  );
  const selectedQuickFilters = useSelector((state: RootState) =>
    getQuickFiltersValues(state, tableNames.manualPayments)
  );

  const renderRow = ({ handleDoubleClick, ...data }) => {
    const keyId = data.paymentId || data.id;
    const { columnWidths, ...columnsData } = data;

    return (
      <Row
        customClass='ui-table__row_clickable'
        onClick={() =>
          handleDoubleClick((data) =>
            history.push(getPathUrl(tableNames.manualPayments, data))
          )
        }
        key={keyId}
        status={data.paymentStatus}>
        {configuration.map((config) => {
          const { id } = config;
          const content = data[id];

          return (
            <Column
              columnWidths={columnWidths}
              customClass={`ui-table__column_${id}`}
              key={id}
              id={id}
              params={{
                ...config,
                valueId: config.id,
                valueType: config.valueType,
              }}
              data={columnsData}
              content={content || '—'}
            />
          );
        })}
      </Row>
    );
  };

  const renderRequestButton = () => {
    const availableTabs = manualPaymentsTabs.filter(
      (tab) =>
        isEnabled(tab.permission) ||
        isDisabledByReason(
          tab.permission,
          permissionReasons.REASON_IS_NOT_AVAILABLE_FOR_SUPPORT
        )
    );

    return availableTabs.length ? (
      <Button
        id='create-manual-payments'
        status='primary'
        onClick={() =>
          history.push(`/manual-payments/${availableTabs[0].path}`)
        }
        text={getTranslate('manualPayments.newRequest.button')}
      />
    ) : null;
  };

  const isSelectedQuickFilters = () => {
    return Boolean(
      Object.keys(selectedQuickFilters).filter(
        (key) => key !== filtersKeys.operationTypeId
      ).length
    );
  };


  const activeQuickFiltersConfig = getQuickFiltersConfig(wlId, tableNames.manualPayments, quickFiltersConfig);


  return (
    <>
      <TopPanelContainer
        name={tableNames.manualPayments}
        filtersConfig={activeQuickFiltersConfig}
        isFilterButton={false}
        hasSelectedFiltersCustom={isSelectedQuickFilters()}
        button={renderRequestButton()}
      />
      <DataListContainer
        tableName={tableNames.manualPayments}
        apiRequest={getMassPayouts}
        rowRender={renderRow}
      />
    </>
  );
};
